import { render, staticRenderFns } from "./changeForm.vue?vue&type=template&id=4a90fe41&scoped=true"
import script from "./changeForm.vue?vue&type=script&lang=js"
export * from "./changeForm.vue?vue&type=script&lang=js"
import style0 from "./changeForm.vue?vue&type=style&index=0&id=4a90fe41&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a90fe41",
  null
  
)

export default component.exports